import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Timesheet, IConnectGetQuery } from '../../types';
import * as Sentry from '@sentry/react';
import { API, graphqlOperation } from 'aws-amplify';
import { getTimesheet, timesheetsByCustomer } from '../../graphql/queries';
import Loader from '../../Components/Loader';
import { message } from 'antd';
import TimesheetForm from './partials/TimesheetForm';
import { CreateTimesheetInput, UpdateTimesheetInput, UpdateTimesheetMutation } from '../../API';
import { updateTimesheet } from '../../graphql/mutations';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import mixpanel from 'mixpanel-browser';
import { GraphQLQuery } from '@aws-amplify/api';
import { LeaveSummary } from 'basealpha-ui';

type Props = RouteComponentProps<{ id: string }, {}, { record: any; breadcrumbs: any }> & IAppStateComponentProps & {};
type State = {
  timesheet?: Timesheet | null;
  loading: boolean;
  leaveSummary?: LeaveSummary | null;
};
class Form extends React.Component<Props, State> {
  state: State = {
    timesheet: null,
    loading: false,
    leaveSummary: undefined,
  };
  getTimesheet = async (accessToFullData: any) => {
    let timesheet;
    if (accessToFullData) {
      let timesheetData = (await API.graphql(
        graphqlOperation(getTimesheet, { id: this.props.match.params.id }),
      )) as IConnectGetQuery<Timesheet, 'getTimesheet'>;
      timesheet = timesheetData?.data?.getTimesheet;
      return timesheet;
    } else {
      const fltr = {
        and: [
          { id: { eq: this.props.match.params.id } },
          {
            or: [
              { approver1: { eq: this.props.appState.user.id } },
              { approver2: { eq: this.props.appState.user.id } },
            ],
          },
        ],
      };

      let timesheetArr: any = [];
      let timesheetObj: any;
      let nextToken = null;
      do {
        timesheetObj = (await API.graphql(
          graphqlOperation(timesheetsByCustomer, {
            customerId: `${this.props.appState.user.customerId}`,
            filter: fltr,
            sortDirection: 'DESC',
            nextToken: nextToken,
            limit: 5,
          }),
        )) as IConnectGetQuery<Timesheet, 'timesheetsByCustomer'>;
        nextToken = timesheetObj?.data?.timesheetsByCustomer?.nextToken;
        if (timesheetObj?.data?.timesheetsByCustomer?.items?.length > 0) {
          timesheetArr.push(timesheetObj);
          break;
        }
      } while (nextToken);
      if (timesheetArr[0]?.data?.timesheetsByCustomer?.items[0]) {
        return timesheetArr[0].data.timesheetsByCustomer.items[0];
      } else {
        return [];
      }
    }
  };
  async componentDidMount(): Promise<void> {
    if (this.props.location.state?.record) {
      // We passed it from the list in the state
      this.setState({
        timesheet: this.props.location.state.record,
      });
      mixpanel.track('View Timesheet', {
        timesheetId: this.props.location.state.record.id,
      });
    }
    if (this.props.match.params.id) {
      // We should load from the API
      try {
        this.setState({
          loading: true,
        });
        let timesheet = await this.getTimesheet(this.props.appState.user.accessToFullData);
        if (timesheet) {
          this.setState({
            timesheet: timesheet,
            loading: false,
          });
          mixpanel.track('View Timesheet', {
            timesheetId: timesheet.id,
          });
          if (timesheet?.id) {
            API.get('EhcmsPortalApi', `/customer/timesheets/${timesheet.id}/leave-summary`, {})
              .then((r: any) => this.setState({ leaveSummary: r?.leaveSummary ?? null }))
              .catch(() => this.setState({ leaveSummary: null }));
          }
        }
      } catch (e) {
        message.error('Timesheet not found');
        this.props.history.goBack();
      }
    }
  }
  save = async (values: CreateTimesheetInput & { approving?: boolean; rejecting?: boolean }): Promise<any> => {
    try {
      if (values.rejecting) {
        try {
          const submitResponse = await API.post('EhcmsPortalApi', '/customer/timesheet/reject', {
            body: {
              timesheetId: values.id,
            },
          });
          message.success('The timesheet was rejected');
          mixpanel.track('Reject Timesheet', {
            timesheetId: values.id,
          });
          this.props.history.push('/timesheets');
          return submitResponse;
        } catch (e: any) {
          const error = e.response?.data?.message || 'Error rejecting timesheet';
          message.error(error);
          Sentry.captureException(e);
        }
      }
      const approving = values.approving;
      if (typeof values.approving !== 'undefined') {
        delete values.approving;
      }
      // const op = updateTimesheet;
      // const opName = 'updateTimesheet';
      // const response = await API.graphql(graphqlOperation(op, { input: values }));
      // if (response && response.data && response.data[opName]) {
      if (approving) {
        try {
          const submitResponse = await API.post('EhcmsPortalApi', '/customer/timesheet/approve', {
            body: {
              timesheetId: values.id,
            },
          });
          message.success('The timesheet was approved');
          mixpanel.track('Approve Timesheet', {
            timesheetId: values.id,
          });
          this.props.history.push('/timesheets');
          return submitResponse;
        } catch (e: any) {
          let error = e.response?.data?.message || 'Error approving timesheet';
          if (
            error ===
            'The number of remaining time off is not sufficient for this time off type.\\nPlease also check the time off waiting for validation.'
          ) {
            error = `You don't have enough leave days available`;
          }
          message.error(error);
          Sentry.captureException(e);
        }
      }
      //     else {
      //       message.success('Your timesheet was saved');
      //       this.props.history.push('/timesheets');
      //       return response.data[opName];
      //     }
      //   } else {
      //     message.error('Failed to save');
      //   }
      //   // return Promise.reject(new Error('Error saving your timesheet'));
    } catch (e) {
      message.error('Failed to save');
      Sentry.captureException(e);
      // return Promise.reject(e);
    }
  };
  submitTimehseet = async (values: CreateTimesheetInput): Promise<any> => {
    try {
      const op = updateTimesheet;
      const opName = 'updateTimesheet';
      const response = await API.graphql<GraphQLQuery<UpdateTimesheetMutation>>(graphqlOperation(op, { input: values }));
      if (response && response.data && response.data[opName]) {
        // return response.data[opName];
        try {
          const submitResponse = API.post('EhcmsPortalApi', '/contractor/timesheet/submit', {
            body: {
              id: values.id,
            },
          });
          message.success('Your timesheet was submitted for approval');
          this.props.history.push('/timesheets');
          return submitResponse;
        } catch (e: any) {
          message.error(e.message);
        }
      }
      return Promise.reject(new Error('Error saving your timesheet'));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  close = (): void => {
    this.props.history.goBack();
  };
  render(): React.ReactElement {
    if (this.state.loading) {
      return <Loader />;
    }
    if (this.state.timesheet) {
      return (
        <TimesheetForm
          record={this.state.timesheet}
          save={this.save}
          submitTimesheet={this.submitTimehseet}
          close={this.close}
          breadcrumbs={this.props.location.state?.breadcrumbs}
          leaveSummary={this.state.leaveSummary ?? null}
        />
      );
    }
    return <Loader />;
  }
}

export default withAppState(Form);
